import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { PLAYER_SERVER_SETTING_PROPERTIES } from '../../types/playerServerSettingsTypes';
import { ServerSettingItemButton } from '../messageBoxes/settingsModal/serverSettingItemButton';
const SETTING_TYPE = 'animated_room_backgrounds';
const CONTAINER_CSS = css `
  display: flex;
  flex-flow: row wrap;
  gap: 0 10px;
  align-items: center;
`;
export const ThemeRoomBackgroundAnimationControl = () => {
    if (PLAYER_SERVER_SETTING_PROPERTIES[SETTING_TYPE].isDisabled) {
        return null;
    }
    return (_jsxs(Typography, { component: 'div', css: CONTAINER_CSS, children: [_jsx("div", { children: "Animation:" }), _jsx(ServerSettingItemButton, { settingType: SETTING_TYPE })] }));
};
